import { apiUrl } from "src/config/host";
import { fetchData } from "src/async/fetch";
import {
  GET_DASHBOARD_DATA,
  GET_DASHBOARD_CRED_DATA,
  // REMOVE_DASHBOARD
} from "./type";

export const setDashboardData = (body) => (dispatch) => {
  dispatch({ type: GET_DASHBOARD_DATA, payload: body });
};

export const manageDashboardData = (body) => async (dispatch) => {
  try {
    const res = await fetchData("POST", `${apiUrl}/dashboard/manage`, body);
    const resData = await res.json();

    if (resData.status === 200) {
      dispatch({ type: GET_DASHBOARD_DATA, payload: resData.data });
      return { message: resData.message, data: resData.data };
    } else {
      throw new Error(resData.message);
    }
  } catch (error) {
    throw new Error(error.message);
  }
};

export const getDashboardData =
  (body, signal = null) =>
  async (dispatch) => {
    try {
      const res = await fetchData("POST", `${apiUrl}/dashboard/list`, body, signal);
      const data = await res.json();

      if (data.status === 200) {
        dispatch({ type: GET_DASHBOARD_DATA, payload: data.data });
        return data.data;
      } else {
        throw new Error(data.message);
      }
    } catch (error) {
      throw new Error(error.message);
    }
  };

export const removeDashboard = (id) => async (dispatch) => {
  try {
    const res = await fetchData("POST", `${apiUrl}/dashboard/delete`, { id });
    const data = await res.json();

    if (data.status === 200) {
      // dispatch({ type: REMOVE_DASHBOARD, payload: id });
      return data.message;
    } else {
      throw new Error(data.message);
    }
  } catch (error) {
    throw new Error(error.message);
  }
};

export const getGroupPermissionData = async (groupIds) => {
  try {
    const res = await fetchData("POST", `${apiUrl}/dashboard/group/permissions`, { groupIds });
    const data = await res.json();

    if (data.status === 200) {
      return data;
    } else {
      throw new Error(data.message);
    }
  } catch (error) {
    throw new Error(error.message);
  }
};

export const getCredData =
  (body, signal = null) =>
  async (dispatch) => {
    try {
      const res = await fetchData("POST", `${apiUrl}/dashboard/credential/get`, body, signal);

      const resData = await res.json();

      if (resData.status === 200) {
        dispatch({ type: GET_DASHBOARD_CRED_DATA, payload: resData.data });
        return resData.data;
      } else {
        throw new Error(resData.message);
      }
    } catch (error) {
      throw new Error(error.message);
    }
  };

export const manageCredData =
  (body, signal = null) =>
  async (dispatch) => {
    try {
      const res = await fetchData("POST", `${apiUrl}/dashboard/credential/manage`, body, signal);

      const resData = await res.json();

      if (resData.status === 200) {
        dispatch({ type: GET_DASHBOARD_CRED_DATA, payload: resData.data });
        return resData;
      } else {
        throw new Error(resData.message);
      }
    } catch (error) {
      throw new Error(error.message);
    }
  };

export const deleteCredData =
  (body, signal = null) =>
  async (dispatch) => {
    try {
      await fetchData("DELETE", `${apiUrl}/dashboard/credential/${body}`, signal);
    } catch (error) {
      throw new Error(error.message);
    }
  };

export const getDomoDashboardList = async (body) => {
  try {
    const res = await fetchData("POST", `${apiUrl}/domo-dashboard/list`, body);
    const data = await res.json();

    if (data.status === 200) {
      return data.data;
    } else {
      throw new Error(data.message);
    }
  } catch (error) {
    throw new Error(error.message);
  }
};

export const getDomoDashboardDetails = async (body) => {
  try {
    const res = await fetchData("POST", `${apiUrl}/domo-dashboard/details`, body);
    const data = await res.json();

    if (data.status === 200) {
      return data;
    } else {
      return data;
    }
  } catch (error) {
    throw new Error(error.message);
  }
};
